export class SelectedCamera {
    label: string;
    id: string;

    constructor(options?: Partial<SelectedCamera>) {
        Object.assign(this, options);
    }
}
